import React, { useCallback } from 'react';
import { Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  resetForm,
  saveSchedule,
  setVisible,
  deleteSchedule,
} from '@store/policies/schedule/actions';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { formModes } from '@store/policies/schedule/formReducer';
import Content from './Content';
import { StyledModal } from './styled';
import { trackModalActions } from './track';
import { Validator } from './Validator';

const modeButtonMap = {
  [formModes.new]: {
    type: 'primary',
    text: 'Save',
    key: 'new',
  },
  [formModes.edit]: {
    type: 'primary',
    text: 'Update',
    key: 'edit',
  },
  [formModes.delete]: {
    type: 'danger',
    text: 'Delete',
    key: 'delete',
  },
};

function ScheduleModal({ canEdit }) {
  const dispatch = useDispatch();
  const { mode, activationState, visible, loading, triggerAt } = useSelector(formViewSelector);

  const onCancel = useCallback(() => {
    dispatch(resetForm());
  }, []);

  const onSubmit = useCallback(() => {
    trackModalActions(mode, activationState);
    if (mode === formModes.delete) {
      dispatch(deleteSchedule(onCancel));
    } else {
      if (moment(triggerAt).isBefore(moment())) {
        message.error('Date can not be in the past.');
        return;
      }
      dispatch(saveSchedule(onCancel));
    }
  }, [onCancel, triggerAt, mode, activationState]);

  const showModal = useCallback(() => {
    dispatch(setVisible(true));
  }, []);

  if (!canEdit) {
    return null;
  }

  const { type, text, key } = modeButtonMap[mode];

  return (
    <>
      <Button onClick={showModal}>Activate Policy</Button>
      {visible && (
        <StyledModal
          visible={visible}
          title={`Activate Policy (${mode[0].toUpperCase() + mode.slice(1)})`}
          onOk={onSubmit}
          onCancel={onCancel}
          footer={[
            <Button key="Cancel" onClick={onCancel}>
              Cancel
            </Button>,
            <Validator key={key} deleteMode={mode === formModes.delete}>
              {(canSubmit) => (
                <Button
                  type={type}
                  key={key}
                  loading={loading}
                  onClick={onSubmit}
                  disabled={!canSubmit}
                >
                  {text}
                </Button>
              )}
            </Validator>,
          ]}
        >
          <Content />
        </StyledModal>
      )}
    </>
  );
}

export default React.memo(ScheduleModal);
